/*
 * jQuery.zip2addr
 *
 * Copyright 2010, Kotaro Kokubo a.k.a kotarok kotaro@nodot.jp
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * https://github.com/kotarok/jQuery.zip2addr
 *
 * Depends:
 *	jQuery 1.4 or above
 */

$.fn.zip2addr = function(target) {

const arrayProvinceJapan = {
    "北海道": "Hokkaidō",
    "青森県": "Aomori",
    "岩手県": "Iwate",
    "宮城県": "Miyagi",
    "秋田県": "Akita",
    "山形県": "Yamagata",
    "福島県": "Fukushima",
    "茨城県": "Ibaraki",
    "栃木県": "Tochigi",
    "群馬県": "Gunma",
    "埼玉県": "Saitama",
    "千葉県": "Chiba",
    "東京都": "Tōkyō",
    "神奈川県": "Kanagawa",
    "新潟県": "Niigata",
    "富山県": "Toyama",
    "石川県": "Ishikawa",
    "福井県": "Fukui",
    "山梨県": "Yamanashi",
    "長野県": "Nagano",
    "岐阜県": "Gifu",
    "静岡県": "Shizuoka",
    "愛知県": "Aichi",
    "三重県": "Mie",
    "滋賀県": "Shiga",
    "京都府": "Kyōto",
    "大阪府": "Ōsaka",
    "兵庫県": "Hyōgo",
    "奈良県": "Nara",
    "和歌山県": "Wakayama",
    "鳥取県": "Tottori",
    "島根県": "Shimane",
    "岡山県": "Okayama",
    "広島県": "Hiroshima",
    "山口県": "Yamaguchi",
    "徳島県": "Tokushima",
    "香川県": "Kagawa",
    "愛媛県": "Ehime",
    "高知県": "Kōchi",
    "福岡県": "Fukuoka",
    "佐賀県": "Saga",
    "長崎県": "Nagasaki",
    "熊本県": "Kumamoto",
    "大分県": "Ōita",
    "宮崎県": "Miyazaki",
    "鹿児島県": "Kagoshima",
    "沖縄県": "Okinawa",

};
    var c = {
        api: 'https://www.google.com/transliterate?langpair=ja-Hira|ja&jsonp=?',
        prefectureToken: '(東京都|道|府|県)',
        zipDelimiter: '-'
    }

    var cache = $.fn.zip2addr.cache;

    var getAddr = function(zip, callback) {
        $.getJSON(c.api, {
                'text': zip
            },
            function(json) {
                if (RegExp(c.prefectureToken).test(json[0][1][0])) {
                    callback(json[0][1][0].replace(RegExp('(.*?' + c.prefectureToken + ')(.+)'), function(a, b, c, d) {
                        return [b, d]
                    }))
                }
            }
        )
    }

    var fillAddr = (function() {
        if (typeof target == 'object' && target.pref) {
            return function(addr) {
                var addrs = addr.split(',');
                if (addrs) {
                    if (!RegExp(addrs[1]).test($(target.addr).val())) {
                        $(target.pref).val(arrayProvinceJapan[addrs[0]]);
                        $(target.addr).val(addrs[1]);
                        $(target.addr1).val(addrs[1]);
                    }
                    let addressProvinceValue = $('#AddressProvinceValue').val();
                    $('#AddressProvinceNew option[value="'+addressProvinceValue+'"]').prop('selected', true);
                } else if (!RegExp(addrs[1]).test($(target.addr).val())) {
                    $(target.pref).add(target.addr).val('');
                }
            }
        } else {
            return function(addr) {
                var addrStr = addr.replace(',', '');
                var addrField = target.addr || target;
                if (addrStr) {
                    if (!RegExp(addrStr).test($(addrField).val())) {
                        $(addrField).val(addrStr);
                    }
                } else if (!RegExp(addrStr).test($(addrField).val())) {
                    $(addrField).val('');
                }
            }
        }
    })()

    //From http://liosk.blog103.fc2.com/blog-entry-72.html
    var fascii2ascii = (function() {
        var pattern = /[\uFF01-\uFF5E]/g,
            replace = function(m) {
                return String.fromCharCode(m.charCodeAt() - 0xFEE0);
            };
        return function(s) {
            return s.replace(pattern, replace);
        };
    })();

    var check = function(_val) {
        var val = fascii2ascii(_val).replace(/\D/g, '');
        if (val.length == 7) {
            if (cache[val] == undefined) {
                getAddr(val.replace(/(\d\d\d)(\d\d\d\d)/, '$1-$2'), function(json) {
                    cache[val] = json;
                    fillAddr(json);
                })
            } else {
                fillAddr(cache[val]);
            }
        }
    }

    this.each(function() {
        var elem = $(this);
        if (typeof target == 'object' && target.zip2) {
            elem.add($(target.zip2))
                .bind('keyup.zip2addr change.zip2addr', function() {
                    check(elem.val() + '' + $(target.zip2).val())
                })
                .bind('blur.zip2addr', function() {
                    $(this).val(function() {
                        return fascii2ascii($(this).val())
                    })
                })
        } else {
            elem
                .bind('keyup.zip2addr change.zip2addr', function() {
                    check(elem.val())
                })
                .bind('blur.zip2addr', function() {
                    $(this).val(function() {
                        return fascii2ascii($(this).val()).replace(/\D/g, '').replace(/(\d\d\d)(\d\d\d\d)/, '$1' + c.zipDelimiter + '$2')
                    })
                })
        }
    });
    let addressProvinceValue = $('#AddressProvinceValue').val();
    $('#AddressProvinceNew option[value="'+addressProvinceValue+'"]').prop('selected', true)
    return this;
};

$.fn.zip2addr.cache = {};
